import React from 'react'

import { MaterialIcon } from '@gravitate-js/excalibrr'

import {
  DownloadOutlined,
  UploadOutlined,
  CheckCircleFilled,
  IdcardFilled,
  FlagOutlined,
  IdcardOutlined,
  EyeOutlined,
  FilterFilled,
  EnvironmentFilled,
  EnvironmentOutlined,
} from '@ant-design/icons'
import { DrivingIcon, DroppingIcon, LoadingIcon } from '@components/OrderDispatch/TripGrid/TripGridCell/TripStatus'

export const TripStatusIcon = ({ status }) => {
  switch (status) {
    case null:
      return null
    case 'unset':
      return null
    case 'assigned_to_driver':
      return <IdcardOutlined icon='schedule' />
    case 'assigned_to_carrier':
      return <FlagOutlined icon='schedule' />
    case 'preview':
      return <EyeOutlined />
    case 'complete':
      return <CheckCircleFilled style={{ fontSize: 20 }} />
    case 'driving to load':
    case 'driving to drop':
    case 'heading home':
      return <DrivingIcon color='var(--theme-color-2)' size={20} />
    case 'loading':
      return <LoadingIcon color='var(--theme-color-2)' size={20} />
    case 'dropping':
      return <DroppingIcon color='var(--theme-color-2)' size={20} />
    case 'arrived at load':
    case 'arrived at drop':
      return <EnvironmentOutlined style={{ fontSize: 20 }} />
    default:
      return null
  }
}
